module.exports = __webpack_public_path__ + "static/media/assembly.0325d23c.jpg";